import { Component } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../model/user.class';
import { AuthHttp } from 'angular2-jwt/angular2-jwt';
import { NgTableComponent } from '../tableModel/ng-table.component';
import { NgTableFilteringDirective } from '../tableModel/ng-table-filtering.directive';
import { NgTablePagingDirective } from '../tableModel/ng-table-paging.directive';
import { NgTableSortingDirective } from '../tableModel/ng-table-sorting.directive';

@Component({
    selector: 'app-user-list',
    templateUrl: './user.list.component.html'
})
export class UserListComponent {

    users: User[];
    columns: Array<any> = [
        {
            title: 'Vorname',
            name: 'firstName',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Vorname filtern' }
        },
        {
            title: 'Nachname',
            name: 'lastName',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Nachname filtern' }
        },
        {
            title: 'Mailadresse',
            name: 'mail',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Mailadresse filtern' }
        },
        {
            title: 'Benutzertyp',
            name: 'userType',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Benutzertyp filtern' }
        },
        {
            title: 'Verlag',
            name: 'publisher',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Verlag filtern' }
        },
    ];

    constructor(public userService: UserService) {
        userService.getAll('user').subscribe(data => this.users = data as User[]);
    }
}



// WEBPACK FOOTER //
// ./src/app/userList/user.list.component.ts